import { useState } from "react";

export const TechnicalProof = ({ items }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="access-studio-technical-proof" style={{ marginTop: "0.5rem" }}>
      <button
        data-testid="access-studio-technical-proof-toggle"
        onClick={() => setOpen((value) => !value)}
        type="button"
        style={{
          border: "1px solid #d1d5db",
          background: "transparent",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "0.75rem",
          padding: "0.2rem 0.6rem",
        }}
      >
        {open ? "Hide technical proof" : "Show technical proof"}
      </button>
      {open && (
        <ul
          data-testid="access-studio-technical-proof-list"
          style={{ margin: "0.5rem 0 0", paddingLeft: "1.1rem", fontSize: "0.78rem", color: "#374151" }}
        >
          {(items || []).map((item, index) => (
            <li key={`${item.file}-${index}`}>
              <code>{item.file}</code>
              {item.symbol ? ` · ${item.symbol}` : ""}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TechnicalProof;
